import React from 'react';
import { Image } from '@chakra-ui/react';
import localCreatorsBanner from '../assets/local-creators-banner.png';

export interface LocalCreatorsBannerLogoProps {
  /** Render height in px; width follows asset aspect ratio (~4.8:1). */
  height?: number;
}

/** LocalCreators wordmark banner for the profile page header. */
const LocalCreatorsBannerLogo: React.FC<LocalCreatorsBannerLogoProps> = ({ height = 28 }) => {
  const width = Math.round(height * (1024 / 213));

  return (
    <Image
      src={localCreatorsBanner}
      alt="LocalCreators"
      h={`${height}px`}
      w={`${width}px`}
      maxW="100%"
      objectFit="contain"
      objectPosition="center"
      flexShrink={0}
      draggable={false}
    />
  );
};

export default LocalCreatorsBannerLogo;
